module.exports = __webpack_public_path__ + "img/wave-mask.6201c7f4.png";